
import React, {Component} from "react";
import * as style from "./style.scss";
// import {Input} from "antd";
import CurrentUserDropDownMenu from "../CurrentUserDropDownMenu/index.js";
import VisionMode from "../VisionMode/index.js";
import {AppLayoutSideBarMenuIcon} from "../Layout/index.js";
import { Link } from 'react-router-dom';
import peacockImage from '../../../Assets/peacock-day.jpg';
import peacockTransImage from '../../../Assets/peacock-trans.png';

/**
 * Header that displays the nbc logo and contains a dropdown menu.
 */
export default class AppHeader extends Component {

    // COMPONENT Render ................................
    render() {
        return (
            <div className={style.appHeader}>
                <div className={style.section}>
                    <AppLayoutSideBarMenuIcon onClick={() => {
                        this.props.onClickToggleLeftSideBar();
                    }}/>
                </div>

               <Link to="/"><div className={style.section}>
                    <img className={style.brandLogo} src={peacockImage} alt={'brand logo'}
                         height={40}/>
                    <img className={style.brandLogoNightMode} src={peacockTransImage}
                         alt={'brand logo'}
                         height={40}/><h3 style={{ verticalAlign: "bottom", fontSize: 24, marginBottom: "-5%", marginLeft: "-5%"}}>STORM</h3>

                </div></Link>

                <div className={style.section} style={{ marginLeft: "-5%" }}>
                    <VisionMode/>
                    <CurrentUserDropDownMenu/>
                </div>
            </div>
        )
    }
}
